import { Navigate, Route } from "react-router";
import { all_routes } from "./all_routes";
import { lazy } from "react";
const ContractType = lazy(() => import("../crm/HR/ContractType"));
const Department = lazy(() => import("../crm/HR/Department"));
const EmployeeCompany = lazy(() => import("../crm/HR/EmployeeCompany"));
const SiteType = lazy(() => import("../crm/HR/SiteType"));
const LeaveTypeList = lazy(() => import("../crm/HR/LeaveType"));
const CustomEmail = lazy(() => import("../communication/CustomEmail"));
const CustomWhatsApp = lazy(() => import("../communication/CustomWhatsApp"));

const DealsDashboard = lazy(() => import("../mainMenu/dealsDashboard"));
export const ForcedChangePassword = lazy(() => import("../auth/forcedChangePassword"));
const Activities = lazy(() => import("../crm/activities"));
const Campaign = lazy(() => import("../crm/campaign"));
const ActivityCalls = lazy(() => import("../crm/activityCalls"));
const ActivityMail = lazy(() => import("../crm/activityMail"));
const ActivityTask = lazy(() => import("../crm/activityTask"));
const CampaignComplete = lazy(() => import("../crm/campaign/campaignComplete"));
const CampaignArchieve = lazy(() => import("../crm/campaign/campaignArchieve"));
const Analytics = lazy(() => import("../crm/analytics"));
const Countries = lazy(() => import("../content/location/countries"));
const ContactDetails = lazy(() => import("../crm/contacts"));
const BlankPage = lazy(() => import("../pages/blankPage"));
const Calendar = lazy(() => import("../mainMenu/apps/calendar"));
const Deals = lazy(() => import("../crm/deals"));
const DealsDetails = lazy(() => import("../crm/deals/dealsDetails"));
const DataTable = lazy(() => import("../tables/dataTable"));
const BasicTable = lazy(() => import("../tables/basicTable"));
const DealsKanban = lazy(() => import("../crm/deals/dealsKanban"));
const DealReports = lazy(() => import("../reports/dealReports"));
const DeleteRequest = lazy(() => import("../userManagement/deleteRequest"));
const Membershipplan = lazy(() => import("../membership/membershipplan"));
const MembershipAddon = lazy(() => import("../membership/membershipaddon"));
const TeamList = lazy(() => import("../crm/teams/teamList"));
const TeamDetails = lazy(() => import("../crm/teams/teamDetails"));
const Notes = lazy(() => import("../application/notes"));
const Cities = lazy(() => import("../content/cities"));
const ComingSoon = lazy(() => import("../pages/comingSoon"));
const Manageusers = lazy(() => import("../userManagement/manageusers"));
const LockScreen = lazy(() => import("../authentication/lockscreen"));
const LeadsDetails = lazy(() => import("../crm/leads"));
const Leads = lazy(() => import("../crm/leads/leads"));
const Companies = lazy(() => import("../crm/companies/companies"));
const Customers = lazy(() => import("../crm/customers/customers"));
const CustomerForm = lazy(() => import("../crm/customers/CustomerForm"));
const Login = lazy(() => import("../auth/login"));
const Register = lazy(() => import("../auth/register"));
const TwoStepVerification = lazy(() => import("../auth/twoStepVerification"));
const EmailVerification = lazy(() => import("../auth/emailVerification"));
const Success = lazy(() => import("../auth/success"));
const ResetPassword = lazy(() => import("../auth/resetPassword"));
const AcceptInvite = lazy(() => import("../auth/acceptInvite"));
const ForgotPassword = lazy(() => import("../auth/forgotPassword"));
const Accordion = lazy(() => import("../uiInterface/base-ui/accordion"));
const Avatar = lazy(() => import("../uiInterface/base-ui/avatar"));
const Borders = lazy(() => import("../uiInterface/base-ui/borders"));
const Breadcrumb = lazy(() => import("../uiInterface/base-ui/breadcrumb"));
const Buttons = lazy(() => import("../uiInterface/base-ui/buttons"));
const ButtonsGroup = lazy(() => import("../uiInterface/base-ui/buttonsgroup"));
const Cards = lazy(() => import("../uiInterface/base-ui/cards"));
const Carousel = lazy(() => import("../uiInterface/base-ui/carousel"));
const Colors = lazy(() => import("../uiInterface/base-ui/colors"));
const Dropdowns = lazy(() => import("../uiInterface/base-ui/dropdowns"));
const Grid = lazy(() => import("../uiInterface/base-ui/grid"));
const Images = lazy(() => import("../uiInterface/base-ui/images"));
const Lightboxes = lazy(() => import("../uiInterface/base-ui/lightbox"));
const Media = lazy(() => import("../uiInterface/base-ui/media"));
const Modals = lazy(() => import("../uiInterface/base-ui/modals"));
const NavTabs = lazy(() => import("../uiInterface/base-ui/navtabs"));
const Offcanvas = lazy(() => import("../uiInterface/base-ui/offcanvas"));
const Pagination = lazy(() => import("../uiInterface/base-ui/pagination"));
const Popovers = lazy(() => import("../uiInterface/base-ui/popover"));
const RangeSlides = lazy(() => import("../uiInterface/base-ui/rangeslider"));
const Progress = lazy(() => import("../uiInterface/base-ui/progress"));
const Spinner = lazy(() => import("../uiInterface/base-ui/spinner"));
const Toasts = lazy(() => import("../uiInterface/base-ui/toasts"));
const Typography = lazy(() => import("../uiInterface/base-ui/typography"));
const Video = lazy(() => import("../uiInterface/base-ui/video"));
const Error404 = lazy(() => import("../pages/error/error-404"));
const Error500 = lazy(() => import("../pages/error/error-500"));
const UnderMaintenance = lazy(() => import("../pages/underMaintenance"));

const Todo = lazy(() => import("../application/todo"));
const Email = lazy(() => import("../application/email"));
const VideoCall = lazy(() => import("../application/call/videoCall"));
const Chat = lazy(() => import("../application/chat"));
const Pages = lazy(() => import("../content/pages"));

const ContactList = lazy(() => import("../crm/contacts/contactList"));
const AddEmployee = lazy(() => import("../crm/contacts/AddEmployee"));
const CompanyReport = lazy(() => import("../reports/companyReport"));
const ContactReport = lazy(() => import("../reports/contactReport"));
const LeadReport = lazy(() => import("../reports/leadReport"));
const ProjectReport = lazy(() => import("../reports/projectReport"));
const TaskReport = lazy(() => import("../reports/taskReport"));
const AudioCall = lazy(() => import("../application/call/audioCall"));
const CallHistory = lazy(() => import("../application/call/callHistory"));
const FileManager = lazy(() => import("../application/fileManager"));
const MembershipTransaction = lazy(() => import("../membership/membershiptrasaction"));
const LeadsKanban = lazy(() => import("../crm/leads/leadskanban"));
const Calls = lazy(() => import("../crmSetting/calls"));
const Industry = lazy(() => import("../crmSetting/industry"));
const Sources = lazy(() => import("../crmSetting/sources"));
const ContactStage = lazy(() => import("../crmSetting/contactStage"));
const RolesPermissions = lazy(() => import("../userManagement/rolesPermissions"));
const ContactMessages = lazy(() => import("../support/contactMessages"));
const Tickets = lazy(() => import("../support/tickets"));
const Faq = lazy(() => import("../content/faq"));
const LostReason = lazy(() => import("../crmSetting/lostReason"));
const ContactGrid = lazy(() => import("../crm/contacts/contactGrid"));
const CompaniesGrid = lazy(() => import("../crm/companies/companiesGrid"));
const Pipeline = lazy(() => import("../crm/pipeline"));
const Projects = lazy(() => import("../crm/projects"));
const Task = lazy(() => import("../crm/task"));
const CompaniesDetails = lazy(() => import("../crm/companies/companiesDetails"));
const States = lazy(() => import("../content/states"));
const Testimonials = lazy(() => import("../content/testimonials"));
const Counter = lazy(() => import("../uiInterface/advanced-ui/counter"));
const DragAndDrop = lazy(() => import("../uiInterface/advanced-ui/dragdrop"));
const Rating = lazy(() => import("../uiInterface/advanced-ui/rating"));
const TextEditor = lazy(() => import("../uiInterface/advanced-ui/texteditor"));
const Timeline = lazy(() => import("../uiInterface/advanced-ui/timeline"));
const Scrollbar = lazy(() => import("../uiInterface/advanced-ui/uiscrollbar"));
const Apexchart = lazy(() => import("../uiInterface/charts/apexcharts"));
const FontawesomeIcons = lazy(() => import("../uiInterface/icons/fontawesome"));
const MaterialIcons = lazy(() => import("../uiInterface/icons/materialicon"));
const PE7Icons = lazy(() => import("../uiInterface/icons/pe7icons"));
const ThemifyIcons = lazy(() => import("../uiInterface/icons/themify"));
const TypiconIcons = lazy(() => import("../uiInterface/icons/typicons"));
const WeatherIcons = lazy(() => import("../uiInterface/icons/weathericons"));
const BasicInputs = lazy(() => import("../uiInterface/forms/formelements/basic-inputs"));
const CheckboxRadios = lazy(() => import("../uiInterface/forms/formelements/checkbox-radios"));
const InputGroup = lazy(() => import("../uiInterface/forms/formelements/input-group"));
const GridGutters = lazy(() => import("../uiInterface/forms/formelements/grid-gutters"));
const FormSelect = lazy(() => import("../uiInterface/forms/formelements/form-select"));
const FormMask = lazy(() => import("../uiInterface/forms/formelements/form-mask"));
const FileUpload = lazy(() => import("../uiInterface/forms/formelements/fileupload"));
const FormHorizontal = lazy(() => import("../uiInterface/forms/formelements/layouts/form-horizontal"));
const FormVertical = lazy(() => import("../uiInterface/forms/formelements/layouts/form-vertical"));
const FloatingLabel = lazy(() => import("../uiInterface/forms/formelements/layouts/floating-label"));
const FormValidation = lazy(() => import("../uiInterface/forms/formelements/layouts/form-validation"));
const FormSelect2 = lazy(() => import("../uiInterface/forms/formelements/layouts/form-select2"));
const FormWizard = lazy(() => import("../uiInterface/forms/formelements/form-wizard"));
const DataTables = lazy(() => import("../uiInterface/table/data-tables"));
const TablesBasic = lazy(() => import("../uiInterface/table/tables-basic"));
const IonicIcons = lazy(() => import("../uiInterface/icons/ionicicons"));
const TasksImportant = lazy(() => import("../crm/task/tasksImportant"));
const TaskCompleted = lazy(() => import("../crm/task/taskCompleted"));
const ActivityMetting = lazy(() => import("../crm/activityMetting"));
const Payments = lazy(() => import("../crm/payments"));
const Proposalslist = lazy(() => import("../crm/proposals/proposalslist"));
const Proposalsgrid = lazy(() => import("../crm/proposals/proposalsgrid"));
const ProposalsView = lazy(() => import("../crm/proposals/proposalsview"));
const Contractslist = lazy(() => import("../crm/contracts/contracts-list"));
const ContractsGrid = lazy(() => import("../crm/contracts/contracts-grid"));
const InvoiceList = lazy(() => import("../crm/invoices/invoicelist"));
const InvoiceGrid = lazy(() => import("../crm/invoices/invoicegrid"));
const EstimationList = lazy(() => import("../crm/estimations/estimation-list"));
const EstimationKanban = lazy(() => import("../crm/estimations/estimation-kanban"));
const Badges = lazy(() => import("../uiInterface/base-ui/badges"));
const Placeholder = lazy(() => import("../uiInterface/base-ui/placeholder"));
const Tooltips = lazy(() => import("../uiInterface/base-ui/tooltips"));
const Ribbon = lazy(() => import("../uiInterface/advanced-ui/ribbon"));
const ProjectDetails = lazy(() => import("../crm/projects/projectdetails"));
const ProjectGrid = lazy(() => import("../crm/projects/projectgrid"));
// Legacy five-flag permission matrix retired at the V2 cutover — no longer routed.
const PermissionTree = lazy(() => import("../userManagement/permissionTree"));
const RoleVisibility = lazy(() => import("../userManagement/RoleVisibility"));
const CalendarVisibility = lazy(() => import("../userManagement/CalendarVisibility"));
const Swiperjs = lazy(() => import("../uiInterface/base-ui/swiper"));
const TablerIcons = lazy(() => import("../uiInterface/icons/tablericons"));
const BootstrapIcons = lazy(() => import("../uiInterface/icons/bootstrapicons"));
const RemixIcons = lazy(() => import("../uiInterface/icons/remixIcons"));
const FormPikers = lazy(() => import("../uiInterface/forms/formpickers"));
const Leaflet = lazy(() => import("../uiInterface/map/leaflet"));
const SocialFeed = lazy(() => import("../application/socialfeed"));
const KanbanView = lazy(() => import("../application/kanbanView"));
const Invoice = lazy(() => import("../application/invoice"));
const InvoiceDetails = lazy(() => import("../application/invoice-details"));
const SuperAdminDashboard = lazy(() => import("../super-admin/dashboard"));
const Company = lazy(() => import("../super-admin/companies"));
const Sortable = lazy(() => import("../uiInterface/base-ui/ui-sortable"));
const Subscription = lazy(() => import("../super-admin/subscription"));
const Packages = lazy(() => import("../super-admin/packages/packagelist"));
const PackagesGrid = lazy(() => import("../super-admin/packages/packagegrid"));
const Domain = lazy(() => import("../super-admin/domin"));
const PurchaseTransaction = lazy(() => import("../super-admin/purchase-transaction"));

const FarmList = lazy(() => import("../crm/farms/farmList"));
// Tenancy §7.1: platform-admin screens (company management, per-company users,
// directional share edges). Gated on the platform_admin claim in ProtectedRoute.
const TenantList = lazy(() => import("../platformAdmin/TenantList"));
const AddCompany = lazy(() => import("../platformAdmin/AddCompany"));
const TenantUsersPage = lazy(() => import("../platformAdmin/TenantUsersPage"));
const TenantModulesPage = lazy(() => import("../platformAdmin/TenantModulesPage"));
const TenantShareList = lazy(() => import("../platformAdmin/TenantShareList"));
const TenantDataCopy = lazy(() => import("../platformAdmin/TenantDataCopy"));
const FarmForm = lazy(() => import("../crm/farms/FarmForm"));
const NotificationTypes = lazy(() => import("../notification/types"));
const NotificationTemplate = lazy(() => import("../notification/template"));
const AllNotifications = lazy(() => import("../notification/AllNotifications"));
const NotificationTemplatePermissions = lazy(() => import("../notification/template-permissions"));
const SystemReport = lazy(() => import("../notification/systemReport"));
// keep admin permissions as deleted or simply replaced

const FarmDetails = lazy(() => import("../crm/farms"));
const FarmGrid = lazy(() => import("../crm/farms/farmGrid"));
const EmployeeTypes = lazy(() => import("../crm/Employee types/employee-types"));
const AllReports = lazy(() => import("../reports/allReports"));
const SubmitReports = lazy(() => import("../reports/submitReports/SubmitReports"));
const Attendance = lazy(() => import("../attendance/Attendance"));
const VanPhoto = lazy(() => import("../vanPhoto/VanPhoto"));
const AuditType = lazy(() => import("../auditors/AuditType/AuditType"));
const Audit = lazy(() => import("../auditors/Audit/Audit"));
const AuditReports = lazy(() => import("../auditors/AuditReport/AuditReports"));
const AuditReportSubmissions = lazy(() => import("../auditors/AuditReportSubmission/SubmitReports"));
const AuditorTimesheet = lazy(() => import("../auditors/AuditorTimesheet/AuditorTimesheet"));
const ShiftList = lazy(() => import("../auditors/Shifts/ShiftList"));
const ExtraWages = lazy(() => import("../crm/HR/ExtraWages"));
const Volunteer = lazy(() => import("../crm/HR/volunteer"));
const ClothingItem = lazy(() => import("../crm/HR/ClothingItem"));
const ClothingRequest = lazy(() => import("../crm/HR/ClothingRequest"));
const ClothingReturn = lazy(() => import("../crm/HR/ClothingReturn"));
const HolidayRequest = lazy(() => import("../crm/HR/HolidayRequest"));
const AreaList = lazy(() => import("../crm/HR/AreaList"));
const TrackingList = lazy(() => import("../crm/HR/TrackingList"));
const CustomerPermissions = lazy(() => import("../customerManagement/customerpermissions"));
const Vehicles = lazy(() => import("../crm/vehicles"));
const DriverTripReport = lazy(() => import("../driverTripReport/DriverTripReport"));
const DriverTripReportSettings = lazy(() => import("../driverTripReport/DriverTripReportSettingsPage"));
const Machines = lazy(() => import("../crm/machines"));
const MachineAssignments = lazy(() => import("../crm/machine-assignments"));
const CustomerRequestReport = lazy(() => import("../auditors/CustomerRequestReport/CustomerRequestReport"));
const Profile = lazy(() => import("../profile/profile"));
const AuditDetails = lazy(() => import("../auditors/Audit/AuditDetails"));
const NCRReports = lazy(() => import("../auditors/NonConfirmancesReport/NCRReport"));
const NCRReportSubmissions = lazy(() => import("../auditors/NCR-Submission/SubmitReports"));
const SanitizedReports = lazy(() => import("../reports/sanitizedReports"));
const Certifications = lazy(() => import("../crm/Certifications"));
const CertificateTypes = lazy(() => import("../crm/CertificateTypes"));
const ManageCustomerPermissions = lazy(() => import("../customerManagement/managecustomerpermissions"));
const CheckInOutSettings = lazy(() => import("../checkInOut/Settings"));
const SystemSettings = lazy(() => import("../settings/SystemSettings"));
const SOPList = lazy(() => import("../sop/SOPList"));
const SOPDetails = lazy(() => import("../sop/SOPDetails"));
const TrainingDashboard = lazy(() => import("../sop/TrainingDashboard"));
const TrainingList = lazy(() => import("../sop/TrainingList"));
const TrainingCategoryList = lazy(() => import("../sop/TrainingCategoryList"));
const TrainingDetails = lazy(() => import("../sop/TrainingDetails"));
const MyTraining = lazy(() => import("../sop/MyTraining"));
const TrainingPlayer = lazy(() => import("../sop/TrainingPlayer"));
const InteractiveElearningDemo = lazy(() => import("../sop/InteractiveElearningDemo"));
const TrainingAssignment = lazy(() => import("../sop/TrainingAssignment"));
const TrainingAssignmentsList = lazy(() => import("../sop/TrainingAssignmentsList"));
const TrainingQuestions = lazy(() => import("../sop/TrainingQuestions"));
const SlideEditor = lazy(() => import("../sop/slides/SlideEditor"));
const TrainingResults = lazy(() => import("../sop/TrainingResults"));
const EscalationList = lazy(() => import("../sop/EscalationList"));
const ImportantDocsList = lazy(() => import("../important-docs/ImportantDocsList"));

const SubmitAuditDocRequest = lazy(() => import("../audit-doc-request/SubmitAuditDocRequest"));
const AuditDocRequestDashboard = lazy(() => import("../audit-doc-request/AuditDocRequestDashboard"));
const TrainingRecordRequestDetailPage = lazy(() => import("../audit-doc-request/TrainingRecordRequestDetailPage"));
const AccessByTokenPage = lazy(() => import("../audit-doc-request/AccessByTokenPage"));
const IncidentReport = lazy(() => import("../auditors/IncidentReport/IncidentReport"));

const InductionPending = lazy(() => import("../induction/InductionPending"));
const InductionDetail = lazy(() => import("../induction/InductionDetail"));
const InductionSettings = lazy(() => import("../induction/InductionSettings"));
const CreateInductionTemplate = lazy(() => import("../induction/CreateInductionTemplate"));

const route = {
  ...all_routes,
  auditType: all_routes.auditType,
  audit: all_routes.audit,
  auditReport: all_routes.auditReport,
  auditReportSubmissions: all_routes.auditReportSubmissions,
  notificationTypes: all_routes.NotificationType,
  notificationSettings: all_routes.NotificationSettings,
  notificationTemplate: all_routes.NotificationTemplate,
  allNotifications: all_routes.AllNotifications,
  notificationTemplatePermissions: all_routes.NotificationTemplatePermissions,
  systemReport: all_routes.SystemReport,
  checkInOutSettings: all_routes.CheckInOutSettings,
  systemSettings: all_routes.SystemSettings,
  sopList: all_routes.sopList,
  trainingDashboard: all_routes.trainingDashboard,
  sopCreate: all_routes.sopCreate,
  sopDetails: all_routes.sopDetails,
  trainingList: all_routes.trainingList,
  trainingCreate: all_routes.trainingCreate,
  trainingEdit: all_routes.trainingEdit,
  trainingCategories: all_routes.trainingCategories,
  sopAssign: all_routes.sopAssign,
  trainingAssignments: all_routes.trainingAssignments,
  auditEscalations: all_routes.auditEscalations,
  trainingQuestions: all_routes.trainingQuestions,
  trainingSlides: all_routes.trainingSlides,
  trainingResults: all_routes.trainingResults,
  myTraining: all_routes.myTraining,
  trainingPlayer: all_routes.trainingPlayer,
};

export const publicRoutes = [
  {
    path: route.dealsDashboard,
    element: <DealsDashboard />,
    route: Route,
    title: "Dashboard",
  },
  {
    path: route.profile,
    element: <Profile />,
    route: Route,
    title: "Profile",
  },
  {
    path: "/",
    name: "Root",
    element: <Navigate to="/login" />,
    route: Route,
    title: "Login",
  },
  {
    path: route.audioCall,
    element: <AudioCall />,
    route: Route,
    title: "Audio Call",
  },
  {
    path: route.callHistory,
    element: <CallHistory />,
    route: Route,
    title: "Call History",
  },
  {
    path: route.leadsKanban,
    element: <LeadsKanban />,
    route: Route,
    title: "Leads Kanban",
  },
  {
    path: route.callHistory,
    element: <CallHistory />,
    route: Route,
    title: "Call History",
  },
  {
    path: route.activities,
    element: <Activities />,
    route: Route,
    title: "Activities",
  },
  {
    path: route.campaign,
    element: <Campaign />,
    route: Route,
    title: "Campaign",
  },
  {
    path: route.activityMeeting,
    element: <ActivityMetting />,
    route: Route,
    title: "Activity Metting",
  },
  {
    path: route.activityCalls,
    element: <ActivityCalls />,
    route: Route,
    title: "Activity Calls",
  },
  {
    path: route.activityMail,
    element: <ActivityMail />,
    route: Route,
    title: "Activity Mail",
  },
  {
    path: route.activityTask,
    element: <ActivityTask />,
    route: Route,
    title: "Activity Task",
  },
  {
    path: route.campaignComplete,
    element: <CampaignComplete />,
    route: Route,
    title: "Campaign Complete",
  },
  {
    path: route.campaignArchieve,
    element: <CampaignArchieve />,
    route: Route,
    title: "Campaign Archieve",
  },
  {
    path: route.analytics,
    element: <Analytics />,
    route: Route,
    title: "Analytics",
  },
  {
    path: route.contactDetails,
    element: <ContactDetails />,
    route: Route,
    title: "Contact Details",
  },
  {
    path: route.blankPage,
    element: <BlankPage />,
    route: Route,
    title: "Blank Page",
  },
  {
    path: route.calendar,
    element: <Calendar />,
    route: Route,
    title: "Calendar",
  },
  {
    path: route.manageusers,
    element: <Manageusers />,
    route: Route,
    title: "Manage Users",
  },

  {
    path: route.membershipplan,
    element: <Membershipplan />,
    route: Route,
    title: "Membership Plan",
  },
  {
    path: route.membershipAddon,
    element: <MembershipAddon />,
    route: Route,
    title: "Membership Addon",
  },
  {
    path: route.membershipTransaction,
    element: <MembershipTransaction />,
    route: Route,
    title: "Membership Transaction",
  },
  {
    path: route.notes,
    element: <Notes />,
    route: Route,
    title: "Notes",
  },
  {
    path: route.contactStage,
    element: <ContactStage />,
    route: Route,
    title: "Contact Stage",
  },
  {
    path: route.countries,
    element: <Countries />,
    route: Route,
    title: "Countries",
  },
  {
    path: route.dataTables,
    element: <DataTable />,
    route: Route,
    title: "Data Table",
  },
  {
    path: route.tablesBasic,
    element: <BasicTable />,
    route: Route,
    title: "Basic Table",
  },
  {
    path: route.dealReports,
    element: <DealReports />,
    route: Route,
    title: "Deal Reports",
  },

  {
    path: route.deals,
    element: <Deals />,
    route: Route,
    title: "Deals",
  },
  {
    path: route.dealsDetails,
    element: <DealsDetails />,
    route: Route,
    title: "Deals Details",
  },
  {
    path: route.dealsKanban,
    element: <DealsKanban />,
    route: Route,
    title: "Deals Kanban",
  },
  {
    path: route.deleteRequest,
    element: <DeleteRequest />,
    route: Route,
    title: "Delete Request",
  },
  {
    path: route.cities,
    element: <Cities />,
    route: Route,
    title: "Cities",
  },
  {
    path: route.companies,
    element: <Companies />,
    route: Route,
    title: "Companies",
  },
  {
    path: route.customers,
    element: <Customers />,
    route: Route,
    title: "Customers",
  },
  {
    path: route.addCustomer,
    element: <CustomerForm />,
    route: Route,
    title: "Add Customer",
  },
  {
    path: route.editCustomer,
    element: <CustomerForm />,
    route: Route,
    title: "Edit Customer",
  },
  // {
  //   path: route.localization,
  //   element: <Localization />,
  //   route: Route,
  //   title: "Localization",
  // },
  {
    path: route.leadsDetails,
    element: <LeadsDetails />,
    route: Route,
    title: "Leads Details",
  },
  {
    path: route.leads,
    element: <Leads />,
    route: Route,
    title: "Leads",
  },
  {
    path: route.companies,
    element: <Companies />,
    route: Route,
    title: "Companies",
  },
  {
    path: route.accordion,
    element: <Accordion />,
    route: Route,
    title: "Accordion",
  },
  {
    path: route.avatar,
    element: <Avatar />,
    route: Route,
    title: "Avatar",
  },
  {
    path: route.badges,
    element: <Badges />,
    route: Route,
    title: "Badges",
  },
  {
    path: route.border,
    element: <Borders />,
    route: Route,
    title: "Borders",
  },
  {
    path: route.breadcrums,
    element: <Breadcrumb />,
    route: Route,
    title: "Breadcrumb",
  },
  {
    path: route.button,
    element: <Buttons />,
    route: Route,
    title: "Buttons",
  },
  {
    path: route.buttonGroup,
    element: <ButtonsGroup />,
    route: Route,
    title: "ButtonsGroup",
  },
  {
    path: route.cards,
    element: <Cards />,
    route: Route,
    title: "Cards",
  },
  {
    path: route.carousel,
    element: <Carousel />,
    route: Route,
    title: "Carousel",
  },
  {
    path: route.colors,
    element: <Colors />,
    route: Route,
    title: "Colors",
  },
  {
    path: route.dropdowns,
    element: <Dropdowns />,
    route: Route,
    title: "Dropdowns",
  },
  {
    path: route.grid,
    element: <Grid />,
    route: Route,
    title: "Grid",
  },
  {
    path: route.images,
    element: <Images />,
    route: Route,
    title: "Images",
  },
  {
    path: route.lightbox,
    element: <Lightboxes />,
    route: Route,
    title: "Lightboxes",
  },
  {
    path: route.media,
    element: <Media />,
    route: Route,
    title: "Media",
  },
  {
    path: route.modals,
    element: <Modals />,
    route: Route,
    title: "Modals",
  },
  {
    path: route.navTabs,
    element: <NavTabs />,
    route: Route,
    title: "NavTabs",
  },
  {
    path: route.offcanvas,
    element: <Offcanvas />,
    route: Route,
    title: "Offcanvas",
  },
  {
    path: route.pagination,
    element: <Pagination />,
    route: Route,
    title: "Pagination",
  },
  {
    path: route.popover,
    element: <Popovers />,
    route: Route,
    title: "Popovers",
  },
  {
    path: route.rangeSlider,
    element: <RangeSlides />,
    route: Route,
    title: "RangeSlides",
  },
  {
    path: route.progress,
    element: <Progress />,
    route: Route,
    title: "Progress",
  },
  {
    path: route.spinner,
    element: <Spinner />,
    route: Route,
    title: "Spinner",
  },

  {
    path: route.typography,
    element: <Typography />,
    route: Route,
    title: "Typography",
  },
  {
    path: route.video,
    element: <Video />,
    route: Route,
    title: "Video",
  },
  {
    path: route.toasts,
    element: <Toasts />,
    route: Route,
    title: "Toasts",
  },
  {
    path: route.underMaintenance,
    element: <UnderMaintenance />,
    route: Route,
    title: "Under Maintenance",
  },


  {
    path: route.todo,
    element: <Todo />,
    route: Route,
    title: "Todo",
  },
  {
    path: route.email,
    element: <Email />,
    route: Route,
    title: "Email",
  },
  {
    path: route.videoCall,
    element: <VideoCall />,
    route: Route,
    title: "Video Call",
  },
  {
    path: route.chat,
    element: <Chat />,
    route: Route,
    title: "Chat",
  },
  {
    path: route.pages,
    element: <Pages />,
    route: Route,
    title: "Pages",
  },
  {
    path: route.contactList,
    element: <ContactList />,
    route: Route,
    title: "Employees",
  },
  {
    path: route.addEmployee,
    element: <AddEmployee />,
    route: Route,
    title: "Add Employee",
  },
  {
    path: route.editEmployee,
    element: <AddEmployee />,
    route: Route,
    title: "Edit Employee",
  },
  {
    path: route.addFarm,
    element: <FarmForm />,
    route: Route,
    title: "Add Farm",
  },
  {
    path: route.editFarm,
    element: <FarmForm />,
    route: Route,
    title: "Edit Farm",
  },
  {
    path: route.FarmDetails,
    element: <FarmDetails />,
    route: Route,
    title: "Farm Details",
  },
  {
    path: route.farmList,
    element: <FarmList />,
    route: Route,
    title: "Farm List",
  },
  {
    path: route.farmGrid,
    element: <FarmGrid />,
    route: Route,
    title: "Farm Grid",
  },

  // HR
  {
    path: route.TrackingList,
    element: <TrackingList />,
    route: Route,
    title: "Tracking",
  },
  {
    path: route.ExtraWages,
    element: <ExtraWages />,
    route: Route,
    title: "Extra Wages",
  },
  {
    path: route.Volunteer,
    element: <Volunteer />,
    route: Route,
    title: "Volunteer",
  },

  {
    path: route.ClothingItem,
    element: <ClothingItem />,
    route: Route,
    title: "Clothing Item",
  },

  {
    path: route.ClothingRequest,
    element: <ClothingRequest />,
    route: Route,
    title: "Clothing Request",
  },

  {
    path: route.ClothingReturn,
    element: <ClothingReturn />,
    route: Route,
    title: "Clothing Return",
  },
  {
    path: route.ClothingReturn,
    element: <ClothingReturn />,
    route: Route,
    title: "Clothing Return",
  },
  {
    path: route.HolidayRequest,
    element: <HolidayRequest />,
    route: Route,
    title: "Holiday Request",
  },
  {
    path: route.areas,
    element: <AreaList />,
    route: Route,
    title: "Areas",
  },
  {
    path: route.ContractType,
    element: <ContractType />,
    route: Route,
    title: "Contract Type",
  },
  {
    path: route.Department,
    element: <Department />,
    route: Route,
    title: "Department",
  },
  {
    path: route.EmployeeCompany,
    element: <EmployeeCompany />,
    route: Route,
    title: "Employee Company",
  },
  {
    path: route.LeaveType,
    element: <LeaveTypeList />,
    route: Route,
    title: "Leave Type",
  },

  // audit
  {
    path: route.auditType,
    element: <AuditType />,
    route: Route,
    title: "Audit Type",
  },
  {
    path: route.audit,
    element: <Audit />,
    route: Route,
    title: "Audit",
  },
  {
    path: route.auditReport,
    element: <AuditReports />,
    route: Route,
    title: "Audit Reports",
  },
  {
    path: route.auditReportSubmissions,
    element: <AuditReportSubmissions />,
    route: Route,
    title: "Audit Report Submissions",
  },
  {
    path: route.auditorTimesheet,
    element: <AuditorTimesheet />,
    route: Route,
    title: "Auditing Clock In/Out Times",
  },
  {
    path: route.shiftList,
    element: <ShiftList />,
    route: Route,
    title: "Shifts",
  },
  {
    path: route.SiteType,
    element: <SiteType />,
    route: Route,
    title: "Site Type",
  },
  {
    path: route.nonConformancesReport,
    element: <NCRReports />,
    route: Route,
    title: "Non Conformances Reports",
  },
  {
    path: route.ncrSubmission,
    element: <NCRReportSubmissions />,
    route: Route,
    title: "NCR Submissions",
  },

  // reports
  {
    path: route.allReports,
    element: <AllReports />,
    route: Route,
    title: "Reports",
  },
  {
    path: route.submissionReports,
    element: <SubmitReports />,
    route: Route,
    title: "Report Submissions",
  },
  {
    path: route.attendance,
    element: <Attendance />,
    route: Route,
    title: "Attendance",
  },
  {
    path: route.vanPhoto,
    element: <VanPhoto />,
    route: Route,
    title: "Van Photo",
  },

  {
    path: route.customerRequestReport,
    element: <CustomerRequestReport />,
    route: Route,
    title: "Customer Request Report",
  },
  {
    path: route.sopList,
    element: <SOPList />,
    route: Route,
    title: "SOP List",
  },
  {
    path: route.sopCreate,
    element: <SOPDetails />,
    route: Route,
    title: "Create SOP",
  },
  {
    path: route.sopEdit,
    element: <SOPDetails />,
    route: Route,
    title: "Edit SOP",
  },
  {
    path: route.sopDetails,
    element: <SOPDetails />,
    route: Route,
    title: "SOP Details",
  },
  {
    path: route.trainingList,
    element: <TrainingList />,
    route: Route,
    title: "Training Modules",
  },
  {
    path: route.trainingCategories,
    element: <TrainingCategoryList />,
    route: Route,
    title: "Training Categories",
  },
  {
    path: route.trainingCreate,
    element: <TrainingDetails />,
    route: Route,
    title: "Create Training",
  },
  {
    path: route.trainingEdit,
    element: <TrainingDetails />,
    route: Route,
    title: "Edit Training",
  },
  {
    path: route.myTraining,
    element: <MyTraining />,
    route: Route,
    title: "My Training",
  },
  {
    path: route.trainingPlayer,
    element: <TrainingPlayer />,
    route: Route,
    title: "Training Player",
  },
  {
    path: route.interactiveElearningDemo,
    element: <InteractiveElearningDemo />,
    route: Route,
    title: "Interactive E-Learning Demo",
  },
  {
    path: route.sopAssign,
    element: <TrainingAssignment />,
    route: Route,
    title: "Assign Training",
  },
  {
    path: route.trainingAssignments,
    element: <TrainingAssignmentsList />,
    route: Route,
    title: "Training Assignments",
  },
  {
    path: route.trainingDashboard,
    element: <TrainingDashboard />,
    route: Route,
    title: "Training Dashboard",
  },
  {
    path: route.trainingQuestions,
    element: <TrainingQuestions />,
    route: Route,
    title: "Training Questions",
  },
  {
    path: route.trainingSlides,
    element: <SlideEditor />,
    route: Route,
    title: "Slide Editor",
  },
  {
    path: route.trainingResults,
    element: <TrainingResults />,
    route: Route,
    title: "Training Results",
  },




  {
    path: route.companyReports,
    element: <CompanyReport />,
    route: Route,
    title: "Company Report",
  },
  {
    path: route.contactReports,
    element: <ContactReport />,
    route: Route,
    title: "Contact Report",
  },
  {
    path: route.dealReports,
    element: <DealReports />,
    route: Route,
    title: "Deal Reports",
  },
  {
    path: route.leadReports,
    element: <LeadReport />,
    route: Route,
    title: "Lead Report",
  },
  {
    path: route.projectReports,
    element: <ProjectReport />,
    route: Route,
    title: "Project Report",
  },
  {
    path: route.taskReports,
    element: <TaskReport />,
    route: Route,
    title: "TaskReport",
  },
  {
    path: route.calls,
    element: <Calls />,
    route: Route,
    title: "Call",
  },
  {
    path: route.contactStage,
    element: <ContactStage />,
    route: Route,
    title: "Contact Stage",
  },
  {
    path: route.industry,
    element: <Industry />,
    route: Route,
    title: "Industry",
  },
  {
    path: route.sources,
    element: <Sources />,
    route: Route,
    title: "Sources",
  },
  {
    path: route.deleteRequest,
    element: <DeleteRequest />,
    route: Route,
    title: "Delete Request",
  },
  {
    path: route.rolesPermissions,
    element: <RolesPermissions />,
    route: Route,
    title: "Roles Permissions",
  },
  {
    path: route.contactMessages,
    element: <ContactMessages />,
    route: Route,
    title: "Contact Messages",
  },
  {
    path: route.tickets,
    element: <Tickets />,
    route: Route,
    title: "Tickets",
  },
  {
    path: route.fileManager,
    element: <FileManager />,
    route: Route,
    title: "File Manager",
  },
  {
    path: route.faq,
    element: <Faq />,
    route: Route,
    title: "Faq",
  },
  {
    path: route.lostReason,
    element: <LostReason />,
    route: Route,
    title: "Lost Reason",
  },
  {
    path: route.contactGrid,
    element: <ContactGrid />,
    route: Route,
    title: "Contact Grid",
  },
  {
    path: route.companiesGrid,
    element: <CompaniesGrid />,
    route: Route,
    title: "Companies Grid",
  },
  {
    path: route.pipeline,
    element: <Pipeline />,
    route: Route,
    title: "Pipeline",
  },
  {
    path: route.projects,
    element: <Projects />,
    route: Route,
    title: "Projects",
  },
  {
    path: route.projectDetails,
    element: <ProjectDetails />,
    route: Route,
    title: "Project Details",
  },
  {
    path: route.projectsGrid,
    element: <ProjectGrid />,
    route: Route,
    title: "Project Grid",
  },
  {
    path: route.tasks,
    element: <Task />,
    route: Route,
    title: "Task",
  },
  {
    path: route.companyDetails,
    element: <CompaniesDetails />,
    route: Route,
    title: "Companies Details",
  },
  {
    path: route.states,
    element: <States />,
    route: Route,
    title: "States",
  },
  {
    path: route.testimonials,
    element: <Testimonials />,
    route: Route,
    title: "Testimonials",
  },
  {
    path: route.counter,
    element: <Counter />,
    route: Route,
    title: "Counter",
  },
  {
    path: route.dragandDrop,
    element: <DragAndDrop />,
    route: Route,
    title: "DragAndDrop",
  },
  {
    path: route.rating,
    element: <Rating />,
    route: Route,
    title: "Rating",
  },
  // {
  //   path: route.stickyNotes,
  //   element: <Stickynote />,
  //   route: Route,
  //   title: "Stickynote",
  // },
  {
    path: route.textEditor,
    element: <TextEditor />,
    route: Route,
    title: "TextEditor",
  },
  {
    path: route.timeLine,
    element: <Timeline />,
    route: Route,
    title: "Timeline",
  },
  {
    path: route.scrollBar,
    element: <Scrollbar />,
    route: Route,
    title: "Scrollbar",
  },
  {
    path: route.apexChat,
    element: <Apexchart />,
    route: Route,
    title: "Apexchart",
  },
  // {
  //   path: route.featherIcons,
  //   element: <FeatherIcons />,
  //   route: Route,
  //   title: "Feather Icons",
  // },
  {
    path: route.fantawesome,
    element: <FontawesomeIcons />,
    route: Route,
    title: "Fontawesome Icons",
  },
  {
    path: route.materialIcon,
    element: <MaterialIcons />,
    route: Route,
    title: "Material Icons",
  },
  {
    path: route.pe7icon,
    element: <PE7Icons />,
    route: Route,
    title: "PE7 Icons",
  },
  {
    path: route.themifyIcon,
    element: <ThemifyIcons />,
    route: Route,
    title: "Themify Icons",
  },
  {
    path: route.typicon,
    element: <TypiconIcons />,
    route: Route,
    title: "Typicon Icons",
  },
  {
    path: route.basicInput,
    element: <BasicInputs />,
    route: Route,
    title: "Basic Inputs",
  },
  {
    path: route.notificationTypes,
    element: <NotificationTypes />,
    route: Route,
    title: "Notification Types",
  },
  {
    path: route.checkInOutSettings,
    element: <CheckInOutSettings />,
    route: Route,
    title: "Check-In/Out Settings",
  },
  {
    path: route.systemSettings,
    element: <SystemSettings />,
    route: Route,
    title: "System Settings",
  },
  {
    path: route.notificationTemplate,
    element: <NotificationTemplate />,
    route: Route,
    title: "Notification Template",
  },
  {
    path: route.allNotifications,
    element: <AllNotifications />,
    route: Route,
    title: "All Notifications",
  },
  {
    path: route.notificationTemplatePermissions,
    element: <NotificationTemplatePermissions />,
    route: Route,
    title: "Notification Permissions",
  },
  {
    path: route.systemReport,
    element: <SystemReport />,
    route: Route,
    title: "System Report",
  },
  {
    path: route.weatherIcon,
    element: <WeatherIcons />,
    route: Route,
    title: "Weather Icons",
  },
  {
    path: route.checkboxandRadion,
    element: <CheckboxRadios />,
    route: Route,
    title: "Checkbox Radios",
  },
  {
    path: route.inputGroup,
    element: <InputGroup />,
    route: Route,
    title: "Input Group",
  },
  {
    path: route.gridandGutters,
    element: <GridGutters />,
    route: Route,
    title: "Grid Gutters",
  },
  {
    path: route.formSelect,
    element: <FormSelect />,
    route: Route,
    title: "Form Select",
  },
  {
    path: route.formMask,
    element: <FormMask />,
    route: Route,
    title: "Form Mask",
  },
  {
    path: route.fileUpload,
    element: <FileUpload />,
    route: Route,
    title: "File Upload",
  },
  {
    path: route.horizontalForm,
    element: <FormHorizontal />,
    route: Route,
    title: "Form Horizontal",
  },
  {
    path: route.verticalForm,
    element: <FormVertical />,
    route: Route,
    title: "Form Vertical",
  },
  {
    path: route.floatingLable,
    element: <FloatingLabel />,
    route: Route,
    title: "Floating Label",
  },
  {
    path: route.formValidation,
    element: <FormValidation />,
    route: Route,
    title: "Form Validation",
  },
  {
    path: route.reactSelect,
    element: <FormSelect2 />,
    route: Route,
    title: "FormSelect2",
  },
  {
    path: route.formWizard,
    element: <FormWizard />,
    route: Route,
    title: "FormWizard",
  },
  {
    path: route.dataTable,
    element: <DataTables />,
    route: Route,
    title: "DataTables",
  },
  {
    path: route.tableBasic,
    element: <TablesBasic />,
    route: Route,
    title: "Tables Basic",
  },
  {
    path: route.iconicIcon,
    element: <IonicIcons />,
    route: Route,
    title: "Ionic Icons",
  },
  {
    path: route.tasksImportant,
    element: <TasksImportant />,
    route: Route,
    title: "Tasks Important",
  },
  {
    path: route.tasksCompleted,
    element: <TaskCompleted />,
    route: Route,
    title: "Task Completed",
  },
  {
    path: route.ProposalsList,
    element: <Proposalslist />,
    route: Route,
    title: "Proposals List",
  },
  {
    path: route.ProposalsGrid,
    element: <Proposalsgrid />,
    route: Route,
    title: "Proposals Grid",
  },
  {
    path: route.ProposalsView,
    element: <ProposalsView />,
    route: Route,
    title: "Proposals View",
  },
  {
    path: route.ContractsList,
    element: <Contractslist />,
    route: Route,
    title: "Contracts List",
  },
  {
    path: route.EmployeeTypes,
    element: <EmployeeTypes />,
    route: Route,
    title: "Employee Types List",
  },
  {
    path: route.teamList,
    element: <TeamList />,
    route: Route,
    title: "Teams",
  },
  {
    path: "/team-details/:id",
    element: <TeamDetails />,
    route: Route,
    title: "Team Details",
  },
  {
    path: route.ContractsGrid,
    element: <ContractsGrid />,
    route: Route,
    title: "Contracts Grid",
  },
  {
    path: route.payments,
    element: <Payments />,
    route: Route,
    title: "Payments",
  },
  {
    path: route.InvoiceList,
    element: <InvoiceList />,
    route: Route,
    title: "Invoice List",
  },
  {
    path: route.InvoiceGrid,
    element: <InvoiceGrid />,
    route: Route,
    title: "Invoice Grid",
  },
  {
    path: route.estimationList,
    element: <EstimationList />,
    route: Route,
    title: "Estimation List",
  },
  {
    path: route.estimationKanban,
    element: <EstimationKanban />,
    route: Route,
    title: "Estimation Kanban",
  },
  {
    path: route.placeholder,
    element: <Placeholder />,
    route: Route,
    title: "Placeholder",
  },
  // {
  //   path: route.sweetalert,
  //   element: <Alert />,
  //   route: Route,
  //   title: "Alert",
  // },
  {
    path: route.tooltip,
    element: <Tooltips />,
    route: Route,
    title: "Tooltips",
  },
  {
    path: route.ribbon,
    element: <Ribbon />,
    route: Route,
    title: "Ribbon",
  },
  {
    // Legacy five-flag matrix retired — the old URL now serves the V2 grant tree
    // so existing bookmarks/links land on the replacement.
    path: route.permissions,
    element: <PermissionTree />,
    route: Route,
    title: "Permission",
  },
  {
    path: route.permissionsV2,
    element: <PermissionTree />,
    route: Route,
    title: "Permissions V2",
  },
  {
    path: route.roleVisibility,
    element: <RoleVisibility />,
    route: Route,
    title: "Role Visibility",
  },
  {
    path: route.calendarVisibility,
    element: <CalendarVisibility />,
    route: Route,
    title: "Calendar Visibility Rules",
  },
  {
    path: route.swiperjs,
    element: <Swiperjs />,
    route: Route,
    title: "Swiperjs",
  },
  {
    path: route.sortable,
    element: <Sortable />,
    route: Route,
    title: "UI SortablesJs",
  },
  {
    path: route.tablericons,
    element: <TablerIcons />,
    route: Route,
    title: "Icon Tabler",
  },
  {
    path: route.bootstrapicons,
    element: <BootstrapIcons />,
    route: Route,
    title: "Icon Bootstap",
  },
  {
    path: route.remixicons,
    element: <RemixIcons />,
    route: Route,
    title: "Icon Remix",
  },
  {
    path: route.formpicker,
    element: <FormPikers />,
    route: Route,
    title: "Form Pickers",
  },
  {
    path: route.mapleaflet,
    element: <Leaflet />,
    route: Route,
    title: "Leaflet Map",
  },
  {
    path: route.socialfeed,
    element: <SocialFeed />,
    route: Route,
    title: "Social feed",
  },
  {
    path: route.kanbanview,
    element: <KanbanView />,
    route: Route,
    title: "Kanban View",
  },
  {
    path: route.invoice,
    element: <Invoice />,
    route: Route,
    title: "Invoice",
  },
  {
    path: route.invoice_details,
    element: <InvoiceDetails />,
    route: Route,
    title: "Invoice Details",
  },
  {
    path: route.superadminDashboard,
    element: <SuperAdminDashboard />,
    route: Route,
    title: "Super Admin Dashboard",
  },
  {
    path: route.superadminCompany,
    element: <Company />,
    route: Route,
    title: "Super Admin Companies",
  },
  {
    path: route.superadminSubscription,
    element: <Subscription />,
    route: Route,
    title: "Super Admin Subscription",
  },
  {
    path: route.superadminPackagelist,
    element: <Packages />,
    route: Route,
    title: "Super Admin Packages",
  },
  {
    path: route.superadminPackageGrid,
    element: <PackagesGrid />,
    route: Route,
    title: "Super Admin Packages Grid",
  },
  {
    path: route.superadminDomain,
    element: <Domain />,
    route: Route,
    title: "Super Admin Domain",
  },
  {
    path: route.superadminPurchaseTransaction,
    element: <PurchaseTransaction />,
    route: Route,
    title: "Super Admin Domain",
  },

  {
    path: route.customerPermissions,
    element: <CustomerPermissions />,
    route: Route,
    title: "Customer Permissions",
  },
  {
    path: "/manage-customer-permissions/:id",
    element: <ManageCustomerPermissions />,
    route: Route,
    title: "Manage Customer Permissions",
  },
  {
    path: route.Vehicles,
    element: <Vehicles />,
    route: Route,
    title: "Vehicles",
  },
  {
    path: route.DriverTripReport,
    element: <DriverTripReport />,
    route: Route,
    title: "Driver Trip Report",
  },
  {
    path: route.DriverTripReportSettings,
    element: <DriverTripReportSettings />,
    route: Route,
    title: "Driver Score Settings",
  },
  {
    path: route.Machines,
    element: <Machines />,
    route: Route,
    title: "Machines",
  },
  {
    path: route.MachineAssignments,
    element: <MachineAssignments />,
    route: Route,
    title: "Machine Assignments",
  },
  {
    path: route.Certifications,
    element: <Certifications />,
    route: Route,
    title: "Certifications",
  },
  {
    path: route.certificateTypes,
    element: <CertificateTypes />,
    route: Route,
    title: "Certificate Types",
  },
  {
    path: route.customEmail,
    element: <CustomEmail />,
    route: Route,
    title: "Custom Email",
  },
  {
    path: route.customWhatsApp,
    element: <CustomWhatsApp />,
    route: Route,
    title: "Custom WhatsApp",
  },
  {
    path: route.importantDocs,
    element: <ImportantDocsList />,
    route: Route,
    title: "Important Documents",
  },
  {
    path: all_routes.auditDetails,
    element: <AuditDetails />,
    route: Route,
    title: "Audit Details",
  },
  {
    path: "/reports/sanitized-reports",
    element: <SanitizedReports />,
    route: Route,
    title: "Sanitized Reports",
  },

  // Training Record Request Routes
  {
    path: route.submitAuditDocRequest,
    element: <SubmitAuditDocRequest />,
    route: Route,
    title: "Submit Training Record Request",
  },
  {
    path: route.auditDocRequestDashboard,
    element: <AuditDocRequestDashboard />,
    route: Route,
    title: "Training Record Requests",
  },
  {
    path: route.trainingRecordRequestDetail,
    element: <TrainingRecordRequestDetailPage />,
    route: Route,
    title: "Training Record Request Detail",
  },
  {
    path: route.accessByToken,
    element: <AccessByTokenPage />,
    route: Route,
    title: "Access Documents by Token",
  },

  // Incident Report
  {
    path: all_routes.incidentReport,
    element: <IncidentReport />,
    route: Route,
    title: "Incident Report",
  },

  // Audit Escalations (training failures escalated to auditors)
  {
    path: all_routes.auditEscalations,
    element: <EscalationList />,
    route: Route,
    title: "Audit Escalations",
  },

  // Employee Induction
  {
    path: all_routes.inductionList,
    element: <InductionPending />,
    route: Route,
    title: "Inductions",
  },
  {
    path: all_routes.inductionPending,
    element: <InductionPending />,
    route: Route,
    title: "Pending Inductions",
  },
  {
    path: all_routes.inductionSettings,
    element: <InductionSettings />,
    route: Route,
    title: "Induction Settings",
  },
  {
    path: all_routes.inductionCreateTemplate,
    element: <CreateInductionTemplate />,
    route: Route,
    title: "Create Induction Template",
  },
  {
    path: all_routes.inductionDetail,
    element: <InductionDetail />,
    route: Route,
    title: "Induction Detail",
  },

  // Tenancy §7.1 (Guides/TENANCY-DESIGN.md): the platform-admin surface.
  //
  // These three paths existed in all_routes, in PLATFORM_ADMIN_ONLY_ROUTES, and
  // in the sidebar — but were never registered as routes here, so React Router
  // had nothing to match. That produced an infinite redirect: login sends a
  // platform admin to /platform-admin/companies, no route matches, the `path="*"`
  // catch-all sends them to getFirstAccessibleRoute() (which, with zero
  // permission keys, resolves to /profile or /dashboard), ProtectedRoute sees
  // isPlatformAdmin and sends them back to /platform-admin/companies — and round
  // again, which is the dashboard <-> companies flicker.
  //
  // Access is gated by ProtectedRoute against the platform_admin CLAIM, not a
  // Permissions V2 key (platform-admin is deliberately not grantable), and the
  // server re-checks it on every request via [RequiresPlatformAdmin].
  {
    path: all_routes.tenants,
    element: <TenantList />,
    route: Route,
    title: "Companies",
  },
  {
    path: all_routes.addTenant,
    element: <AddCompany />,
    route: Route,
    title: "New Company",
  },
  {
    path: all_routes.tenantUsers,
    element: <TenantUsersPage />,
    route: Route,
    title: "Company Users",
  },
  {
    path: all_routes.tenantModules,
    element: <TenantModulesPage />,
    route: Route,
    title: "Company Modules",
  },
  {
    path: all_routes.tenantShares,
    element: <TenantShareList />,
    route: Route,
    title: "Data Sharing",
  },
  {
    path: all_routes.tenantDataReplication,
    element: <TenantDataCopy />,
    route: Route,
    title: "Data Replication",
  },

];

export const authRoutes = [
  {
    path: route.comingSoon,
    element: <ComingSoon />,
    route: Route,
    title: "ComingSoon",
  },
  {
    path: route.login,
    element: <Login />,
    route: Route,
    title: "Login",
  },
  {
    path: route.register,
    element: <Register />,
    route: Route,
    title: "Register",
  },
  {
    path: route.twoStepVerification,
    element: <TwoStepVerification />,
    route: Route,
    title: "TwoStepVerification",
  },
  {
    path: route.emailVerification,
    element: <EmailVerification />,
    route: Route,
    title: "EmailVerification",
  },
  {
    path: route.success,
    element: <Success />,
    route: Route,
    title: "Success",
  },

  {
    path: route.resetPassword,
    element: <ResetPassword />,
    route: Route,
    title: "Reset Password",
  },
  {
    path: route.acceptInvite,
    element: <AcceptInvite />,
    route: Route,
    title: "Company Invitation",
  },
  {
    path: route.forgotPassword,
    element: <ForgotPassword />,
    route: Route,
    title: "Forgot Password",
  },
  {
    path: route.error404,
    element: <Error404 />,
    route: Route,
    title: "Error404",
  },
  {
    path: route.error500,
    element: <Error500 />,
    route: Route,
    title: "Error500",
  },
  {
    path: route.underMaintenance,
    element: <UnderMaintenance />,
    route: Route,
    title: "Under Maintenance",
  },
  {
    path: route.lockScreen,
    element: <LockScreen />,
    route: Route,
    title: "Lock Screen",
  },
];
